// extracted by mini-css-extract-plugin
var _1 = "JjRX2IMGLh";
export { _1 as "toaster" }
